import TextLanguage from '../../../data/TextLanguage.json';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Autocomplete, IconButton, TextField } from '@mui/material';
import TextFilter from '../../DataTable/TextFilter';
import { LDMNumberFilter } from '../../DataTable/components/LDMNumberFilter';

export const ArchiveFilter = ({ filterOptions, hospitalFilterList, selectedFilterUserID, setselectedFilterUserID, lang, setNavbarArchivePatientFilter, setSelectHospitalFilterOpen }) => {


    return <div className='NavbarPaymentFilter'>
        {<Autocomplete
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            filterOptions={filterOptions}
            noOptionsText={"No Matches"}
            size={'small'}
            selectOnFocus
            clearOnBlur
            value={hospitalFilterList?.find(option => option?.value === selectedFilterUserID) || null}
            options={!!hospitalFilterList ?
                hospitalFilterList?.sort((a, b) => -b?.label?.localeCompare(a?.label))
                :
                [{ label: 'Loading...', value: null }]}
            onChange={(e, value) => {
                setselectedFilterUserID(value?.value);
            }}
            getOptionLabel={(option) => `${option?.label}`}
            renderInput={(params) => <TextField {...params} label={TextLanguage["FilterByHospital"][lang]} />}
            sx={{
                width: '100% !important', minWidth: '270px !important', maxWidth: '300px !important',
                '& .MuiFormControl-root': { height: '45px !important', width: '100% !important' },
                '& .MuiInputBase-root': { height: '100%' }
            }} />}

        <TextFilter numberInput={true} labelName={`RBK ${TextLanguage["RefNo"][lang]}`} onFilter={(filter) => { setNavbarArchivePatientFilter(prev => ({ ...prev, caseNumber: filter })); }} placeholderTemplate={`RBK###`} />

        <LDMNumberFilter
            onFilter={(filter) => { setNavbarArchivePatientFilter(prev => ({ ...prev, LDMCaseNoInt: filter })); }}
            onFilterYear={(filter) => { setNavbarArchivePatientFilter(prev => ({ ...prev, LDMCaseNoYear: filter })); }}
            labelName={`LDM ${TextLanguage["RefNo"][lang]}`} />

            <IconButton sx={{
                borderRadius: '4px',
                border: '1px solid #cccccca8',
                padding: '0px',
                height: '56px',
                '&:hover': { backgroundColor: '#3b3b3bff' }
            }} onClick={() => { setSelectHospitalFilterOpen(prev => !prev); }}>
                <ArrowDropDownIcon sx={{ transform: 'rotate(90deg)', transition: 'transform 0.3s ease' }} />
            </IconButton>


    </div>;
};
